import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetTopNewsHarvestQueryResponse } from "../types/GetTopNewsHarvest";

export const getTopNewsHarvestQueryKey = () =>     [{url:`/api/ms-content-infoportal-backend/v1/publications/topNews/harvest`}] as const;
      export function getTopNewsHarvestQueryOptions <TData = GetTopNewsHarvestQueryResponse, TError = unknown>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getTopNewsHarvestQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/ms-content-infoportal-backend/v1/publications/topNews/harvest`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/ms-content-infoportal-backend/v1/publications/topNews/harvest
 */

export function useGetTopNewsHarvest <TData = GetTopNewsHarvestQueryResponse, TError = unknown>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTopNewsHarvestQueryKey();

  const query = useQuery<TData, TError>({
    ...getTopNewsHarvestQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
